$(document).ready(function () {
  $('.clickme a').click(function () {
    $('.clickme a').removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).data('tag');
    $('.list').removeClass('active').addClass('hide');
    $('#' + tagid).addClass('active').removeClass('hide');
  });



  $('.accordion .accordion__item:nth-child(1) .accordion__head').addClass('active');
  $('.accordion .accordion__item:nth-child(1) .accordion__content').slideDown();
  $('.accordion__head').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).siblings('.accordion__content').slideUp();
      $(this).removeClass('active');
    } else {
      $('.accordion__content').slideUp();
      $('.accordion__head').removeClass('active');
      $(this).siblings('.accordion__content').slideToggle();
      $(this).toggleClass('active');
    }
  });



  $('.icon-tabs__header  button').on('click', function (evt) {
    evt.preventDefault();
    var tabID = $(this).attr('data-id');
    $(this).addClass('active').siblings().removeClass('active');
    $('#tab-' + tabID).addClass('active').siblings().removeClass('active');

  });




  $('.acc-head').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).siblings('.inner').slideUp();
      $(this).removeClass('active');
    } else {
      $('.inner').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.inner').slideToggle();
      $(this).toggleClass('active');
    }
  });






  $('.product-form__input').find('input[name="Order"]').each(function (index) {
    if ($(this).val() == "Join the Waitlist") {
      $(this).trigger('click');
      console.log("click");
    }

  });


// old code 

//   function postMessageToPlayer(player, command) {
//     if (player == null || command == null) return;
//     player.contentWindow.postMessage(JSON.stringify(command), "*");
//   }


//   function playPauseVideo(slick, control) {
//     var currentSlide, slideType, startTime, player, video;


//     currentSlide = slick.find(".slick-current");
//     slideType = currentSlide.attr("class").split(" ")[1];
//     player = currentSlide.find("iframe").get(0);
//     startTime = currentSlide.data("video-start");

//     console.log(slideType);

//     if (slideType === "vimeo") {
//       switch (control) {
//         case "play":
//           if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
//             currentSlide.addClass('started');
//             postMessageToPlayer(player, {
//               "method": "setCurrentTime",
//               "value": startTime
//             });
//           }
//           postMessageToPlayer(player, {
//             "method": "play",
//             "value": 1
//           });
//           break;
//         case "pause":
//           postMessageToPlayer(player, {
//             "method": "pause",
//             "value": 1
//           });
//           break;
//       }
//     } else if (slideType === "youtube") {
//       switch (control) {
//         case "play":
//           postMessageToPlayer(player, {
//             "event": "command"
//           });
//           postMessageToPlayer(player, {
//             "event": "command",
//             "func": "playVideo"
//           });
//           break;
//         case "pause":
//           postMessageToPlayer(player, {
//             "event": "command",
//             "func": "pauseVideo"
//           });
//           break;
//       }
//     } else if (slideType === "video") {
//       video = currentSlide.children("video").get(0);
//       if (video != null) {
//         if (control === "play") {
//           video.play();
//         } else {
//           video.pause();
//         }
//       }
//     }
//      else if (slideType === "wistia") {
//   const currentIframe = currentSlide.find("iframe.wistia_embed").get(0);
//   const allIframes = $("iframe.wistia_embed");

//   if (currentIframe) {
//     const currentId = currentIframe.src.split("/embed/iframe/")[1].split("?")[0];

//     const onPlayerReady = (player, isCurrent) => {
//       if (isCurrent) {
//         if (control === "play") {
//           player.unmute();
//           player.play();
//         } else {
//           player.pause();
//         }
//       } else {
//         player.pause();
//       }
//     };

//     function waitForWistiaAPI(callback) {
//       if (typeof Wistia !== "undefined" && typeof Wistia.api === "function") {
//         callback();
//       } else {
//         setTimeout(() => waitForWistiaAPI(callback), 50);
//       }
//     }

//     waitForWistiaAPI(() => {
//       allIframes.each(function () {
//         const iframe = this;
//         const id = iframe.src.split("/embed/iframe/")[1].split("?")[0];
//         const isCurrent = (iframe === currentIframe);

//         const player = Wistia.api(id);
//         if (player) {
//           onPlayerReady(player, isCurrent);
//         } else {
//           window._wq = window._wq || [];
//           _wq.push({
//             id,
//             onReady: (player) => onPlayerReady(player, isCurrent)
//           });
//         }
//       });
//     });
//   }
// }




//   }




//   function videoSlider() {

//     var slideWrapper = $('.video-slider__main');


//     slideWrapper.slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       fade: true,
//       asNavFor: '.video-slider__thumbs',
//       adaptiveHeight: true
//     });
//     $('.video-slider__thumbs').slick({
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       asNavFor: '.video-slider__main',
//       dots: false,
//       focusOnSelect: true,
//       infinite: false,
//       responsive: [{
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2
//           }
//         },
//         {
//           breakpoint: 991,
//           settings: {
//             slidesToShow: 1
//           }
//         }
//       ]
//     });


//     // slideWrapper.on("init", function(slick){
//     //   slick = $(slick.currentTarget);
//     //   setTimeout(function(){
//     //     playPauseVideo(slick,"play");
//     //   }, 1000);
//     //   //resizePlayer(iframes, 16/9);
//     // });


//     slideWrapper.on("beforeChange", function (event, slick) {
//       slick = $(slick.$slider);
//       playPauseVideo(slick, "pause");

//     });
//     slideWrapper.on("afterChange", function (event, slick) {
//       slick = $(slick.$slider);
//       playPauseVideo(slick, "play");
//     });



//     $('.video-slider__thumbs').on("beforeChange", function (event, slick, currentSlide) {

//       // var slider_item =  $('.video-slider-item.slick-current').find('iframe');
//       // var vidosrc =  $('.thumb__item.slick-current').data('video-src');
//       // // slider_item.attr("src", vidosrc);
//       //  slider_item.attr("src", vidosrc+"&autoplay=1");


//     });

//     // $('.video-slider__thumbs').on("afterChange", function(event, slick, currentSlide) {
//     //   var mainslider  =  $('.video-slider__main');
//     //   playPauseVideo(mainslider,"play");


//     // });

//     //    $( ".thumb__item" ).each(function( index ) {
//     //           $(this).on( "click", function(evt) {
//     //             evt.preventDefault();
//     //             var slider_item =  $('.video-slider-item.slick-current').find('iframe');
//     //             var vidosrc =  $('.thumb__item.slick-current').data('video-src');
//     //             slider_item.attr("src", vidosrc);


//     //             var mainslider  =  $('.video-slider__main');
//     //              playPauseVideo(mainslider,"play");

//     //           });

//     // });



//   }





//   videoSlider();


//   document.addEventListener('shopify:block:select', () => videoSlider());
//   document.addEventListener('shopify:block:deselect', () => videoSlider());
//   document.addEventListener('shopify:section:select', () => videoSlider());
//   document.addEventListener('shopify:section:deselect', () => videoSlider());

// old code 

  function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }


function playPauseVideo(slick, control) {
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

  console.log(slideType);

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value": startTime
          });
        }
        // Unmute Vimeo video
        postMessageToPlayer(player, {
          "method": "setVolume",
          "value": 1 // volume max (1)
        });
        postMessageToPlayer(player, {
          "method": "play",
          "value": 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "unMute"  // unmute before play
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play") {
        video.muted = false;  // unmute native video
        video.volume = 1;     // set volume max
        video.play();
      } else {
        video.pause();
      }
    }
  } else if (slideType === "wistia") {
    const currentIframe = currentSlide.find("iframe.wistia_embed").get(0);
    const allIframes = $("iframe.wistia_embed");

    if (currentIframe) {
      const currentId = currentIframe.src.split("/embed/iframe/")[1].split("?")[0];

      const onPlayerReady = (player, isCurrent) => {
        if (isCurrent) {
          if (control === "play") {
            player.unmute();  // unmute Wistia
            player.play();
          } else {
            player.pause();
          }
        } else {
          player.pause();
        }
      };

      function waitForWistiaAPI(callback) {
        if (typeof Wistia !== "undefined" && typeof Wistia.api === "function") {
          callback();
        } else {
          setTimeout(() => waitForWistiaAPI(callback), 50);
        }
      }

      waitForWistiaAPI(() => {
        allIframes.each(function () {
          const iframe = this;
          const id = iframe.src.split("/embed/iframe/")[1].split("?")[0];
          const isCurrent = (iframe === currentIframe);

          const player = Wistia.api(id);
          if (player) {
            onPlayerReady(player, isCurrent);
          } else {
            window._wq = window._wq || [];
            _wq.push({
              id,
              onReady: (player) => onPlayerReady(player, isCurrent)
            });
          }
        });
      });
    }
  }
}


function videoSlider() {
  var slideWrapper = $('.video-slider__main');

  $('.video-slider__main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.video-slider__thumbs',
    adaptiveHeight: true,
    infinite: false,
  });

  $('.video-slider__thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.video-slider__main',
    dots: false,
    focusOnSelect: true,
    infinite: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 }},
      { breakpoint: 991, settings: { slidesToShow: 1 }}
    ]
  });

  // // Pause all videos BEFORE slide changes, but don't play
  slideWrapper.on("beforeChange", function (event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick, "pause");
  });

  // // Remove autoplay on afterChange - user triggers play manually
  slideWrapper.on("afterChange", function (event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick, "pause");
  });

  // // Play video when play icon clicked, pause all others
  // slideWrapper.on("click", ".custom-play-button", function (e) {
  //   e.preventDefault();

  //   // Pause all videos first (including those in other slides)
  //   $('.video-slider__main .slick-slide').each(function() {
  //     const slide = $(this);
  //     const iframe = slide.find('iframe').get(0);
  //     const video = slide.find('video').get(0);
  //     if (iframe) {
  //       // Pause iframe videos via postMessage
  //       postMessageToPlayer(iframe, { event: "command", func: "pauseVideo" });
  //       // For Vimeo, add your pause logic here if needed
  //     }
  //     if (video) {
  //       video.pause();
  //     }
  //     // For Wistia, use your Wistia pause logic if necessary (optional)
  //   });

  //   // Play only clicked slide video
  //   const slick = $(this).closest('.video-slider__main');
  //   playPauseVideo(slick, "play");

  //   // Hide play button on current slide
  //   $(".custom-play-button").show();
  //   $(this).hide();
  // });

  // // Show play icon only on non-playing slides
  // slideWrapper.on("afterChange", function () {
  //   $(".custom-play-button").show();
  //   $(".slick-slide.slick-current").find(".custom-play-button").hide();
  // });

  // // Initial state: show play icons on all slides
  // $(".custom-play-button").show();
}

videoSlider();

document.addEventListener('shopify:block:select', () => videoSlider());
document.addEventListener('shopify:block:deselect', () => videoSlider());
document.addEventListener('shopify:section:select', () => videoSlider());
document.addEventListener('shopify:section:deselect', () => videoSlider());



  function videoYoutubeSlider() {
    // video-block__slider

    $('.video-block__slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });


  }

  // videoYoutubeSlider();
  // document.addEventListener('shopify:block:select', () => videoYoutubeSlider());
  // document.addEventListener('shopify:block:deselect', () => videoYoutubeSlider());
  // document.addEventListener('shopify:section:select', () => videoYoutubeSlider());
  // document.addEventListener('shopify:section:deselect', () => videoYoutubeSlider());






});






























$(document).on("click", ".btn--checkout", function (e) {
  e.preventDefault();


  var check = $('.form__group--check input[type="checkbox"]');
  console.log(check.is(":checked"));

  if (check.is(":checked")) {
    window.location.href = "/checkout";
    return false;
  } else {

    alert('You must agree to the terms and conditions before continuing.');

    return false;
  }

});

// product-form__input

//   $(document).on("click",".newsletter-btn",function(e) {
//     e.preventDefault();

//     console.log("click");

//   $('#BIS_frame').css({'display': 'block'});
//   $('#BIS_frame').contents().find('body').addClass( "fadein bis-popover-active" );
//   $('#BIS_frame').contents().find('#variant-select-container').hide();

// });



$(document).on("click", ".custom-trigger", function (e) {
  e.preventDefault();
  $(this).css("pointer-events", "none");
  $('.land-hero__newslatter input[name="contact[email]"]').select();

});



// $(document).ready(function(){
//   $("#BIS_trigger").trigger("click");

//   console.log( $("#BIS_trigger").trigger("click"));
// });

$('.land-hero__newslatter input[name="contact[email]"]').keyup(function (e) {
  e.preventDefault();
  var dInput = this.value;

  $('.custom-trigger').css("pointer-events", "none");

  var target_email = $('#BIS_frame').contents().find('#email-address input[type="email"]');
  target_email.val(dInput);

});

$(document).on("click", ".newsletter-btn", function (e) {
  e.preventDefault();
  var submitbtn = $('#BIS_frame').contents().find('#submit-btn');
  submitbtn.trigger("click");

  setTimeout(() => {

    $('.success-message').show();

  }, 1000);

  console.log(submitbtn);
});





$('.store-search').on('input', function () {
  $('.listings .item').addClass('hide-item');
  var my_inp = $(this).val().toLowerCase();
  $('.listings .item').each(function () {
    var className = $(this).attr('class');
    if (className.indexOf(my_inp) != -1) {
      // console.log(my_inp + " found");
      $(this).addClass('show-item');
    } else {
      $(this).removeClass('show-item');
    }
  })

});



$(".product__signup-btn").on('click', function () {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'SwtcnH']);

});